import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ccfac69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentLeft" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "article" }
const _hoisted_4 = { class: "aiticleDate" }
const _hoisted_5 = { class: "articleMonth" }
const _hoisted_6 = { class: "articleDay" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "articleType" }, null, -1))
const _hoisted_8 = { class: "articleContent" }
const _hoisted_9 = { class: "article-header" }
const _hoisted_10 = { class: "article-meta" }
const _hoisted_11 = { class: "article-meta-date" }
const _hoisted_12 = { class: "article-meta-visitors" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_14 = { class: "articleBody" }
const _hoisted_15 = { class: "fullArticle" }
const _hoisted_16 = { class: "pageNav" }

import VContent from "@/components/editCompoents/VContent.vue";
import { reactive, onMounted } from "vue";
import { parseTime } from "@/functions/utils/DateUtils";
import { ArticleResults } from "@/api/apitypes/response/ArticleResponse";
import { postPageArticles } from "@/api/functions/home";
import {
  ArticlePagingSearchRequest,
  initArticlePagingSearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainContent',
  setup(__props) {

const state = reactive({
  articleList: [] as ArticleResults[],
  totalCount: 0,
});

const articlePagingSearchRequest: ArticlePagingSearchRequest =
  initArticlePagingSearchRequest();

const getArticleList = async () => {
  await postPageArticles(articlePagingSearchRequest).then((res) => {
    state.articleList = res.data.articles;
    state.totalCount = res.data.totalCount;
  });
};

const handleCurrentChange = (val: number) => {
  articlePagingSearchRequest.pageNo = val;
  getArticleList();
};

onMounted(async () => {
  await getArticleList();
  var scrollDom = document.getElementById("contentLeft") as HTMLElement;
  window.scrollTo({
    top: scrollDom.getBoundingClientRect().top,
    behavior: "smooth",
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_View = _resolveComponent("View")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.articleList, (article) => {
        return (_openBlock(), _createElementBlock("article", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(parseTime)(article.createTime, "{m}")) + "月 ", 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(parseTime)(article.createTime, "{d}")), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("header", _hoisted_9, [
              _createElementVNode("h1", null, [
                _createVNode(_component_router_link, {
                  class: "article-title",
                  to: {
                  name: 'detail',
                  params: { theme: article.theme },
                }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(article.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AlarmClock)
                    ]),
                    _: 1
                  }),
                  _createTextVNode("  "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("menus.home.createTime")) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(parseTime)(article.createTime, "{y}-{m}-{d}")), 1)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_View)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, " " + _toDisplayString(article.visits), 1),
                  _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t("menus.home.visitsCount")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(VContent, {
                content: article.content
              }, null, 8, ["content"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                class: "fullbutton",
                to: {
                name: 'detail',
                params: { theme: article.theme },
              }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 阅读全文 » ")
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]))
      }), 256))
    ]),
    _createElementVNode("nav", _hoisted_16, [
      _createVNode(_component_el_pagination, {
        "page-size": _unref(articlePagingSearchRequest).pageSize,
        background: "",
        layout: "prev, pager, next",
        onCurrentChange: handleCurrentChange,
        total: state.totalCount
      }, null, 8, ["page-size", "total"])
    ])
  ]))
}
}

})